import appRatings from "../../views/appCustomers/ratings.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("ratings", {
    url: "ratings",
    parent: "app",
    views: {
      view: {
        template: appRatings,
      },
    },
    reloadOnSearch: false,
    data: { title: "Ratings" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/ratings/ratings.urls.js